require 'core-js'
require 'regenerator-runtime/runtime'
require 'current-script-polyfill'

# Add touch or no-touch classes to the document so we can have custom css for each
# Based on
#   http://stackoverflow.com/questions/11387805/media-query-to-detect-if-device-is-touchscreen
#   https://gist.github.com/martinwolf/5812337
document.documentElement.className += if 'ontouchstart' of document.documentElement or 'ontouchstart' of window or
  navigator.msMaxTouchPoints > 0 then ' touch' else ' no-touch'

require 'angular'
require 'angular-ui-bootstrap'
require 'angular-route'
require 'angular-resource'
require 'ng-file-upload/dist/angular-file-upload'
require 'ng-file-upload/dist/angular-file-upload-shim'
require 'angular-ui-router'
require 'angular-rich-text-diff'
require 'oclazyload'

require './lib'
require './settings'
require './core'
require './api'
require './app'
require './webfont'
